module.exports = __webpack_public_path__ + "img/20190530161219QQ截图20190527164924.b4d05c06.png";